import { createContext, useContext, useEffect, useReducer } from "react";
import { jwtDecode } from "jwt-decode";

//  Initial State
const initialState = {
  user: null,
  loading: false,
  data: [], // Master data will go here
};


//  Reducer
const appReducer = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_DATA":
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

//  Create Context
const AppContext = createContext();

//  Provider
export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  useEffect(() => {
    // Read token from localStorage or sessionStorage
    const token = localStorage.getItem("accessToken"); // or sessionStorage.getItem("token")

    if (token) {
      try {
        const decoded = jwtDecode(token);
        dispatch({ type: "SET_USER", payload: decoded });
      } catch (err) {
        console.error("Invalid token:", err);
        // Optionally remove invalid token
        localStorage.removeItem("token");
      }
    }
  }, []);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

//  Custom Hook
export const useAppContext = () => useContext(AppContext);
